import type { OrderHistoryParams } from './orderContracts'

// Order query keys factory.
// Mutations invalidate via the factory only — never raw arrays.

export type OrderHistoryQueryKey = Omit<OrderHistoryParams, 'page' | 'limit'>

export const orderKeys = {
  all: ['order'] as const,
  details: () => [...orderKeys.all, 'detail'] as const,
  detail: (id: string) => [...orderKeys.details(), id] as const,
  histories: () => [...orderKeys.all, 'history'] as const,
  history: (params: OrderHistoryQueryKey) => [...orderKeys.histories(), params] as const,
  filters: () => [...orderKeys.all, 'filters'] as const,
  calculateFees: (offeringId: string, tokenQuantity: number) =>
    [...orderKeys.all, 'calculate-fees', offeringId, tokenQuantity] as const,
  /** Receipt PDF blob — never changes, cached for the session. */
  receipt: (orderId: string) => [...orderKeys.all, 'receipt', orderId] as const,
  documents: (orderId: string) => [...orderKeys.all, 'documents', orderId] as const,
  /** A fetched document blob, keyed by its CDN url. */
  documentFile: (url: string) => [...orderKeys.all, 'document-file', url] as const,
  /** First history page (newest 50) — used to find a holding's order. */
  recentOrders: () => [...orderKeys.all, 'recent'] as const,
}
